import httpClient from "./httpClient";

export const authAPI = {
  login: (code) => {
    return httpClient.post("/api/v1/auth/login", { code });
  },
  sync: (code, planType) => {
    return httpClient.post("/api/v1/auth/sync", { code, plan_type: planType });
  },
  logout: () => {
    return httpClient.post("/api/v1/auth/logout");
  },
};

export const userAPI = {
  getUser: () => {
    return httpClient.get("/api/v1/users/me");
  },
  toggleSignature: (enabled) => {
    return httpClient.put("/api/v1/users/signature", {
      enabled,
    });
  },
  deleteAccount: () => {
    return httpClient.delete(`/api/v1/users`);
  },
};

export const subscriptionAPI = {
  cancel: () => {
    return httpClient.put(`/api/v1/subscriptions/cancel`);
  },
  resume: () => {
    return httpClient.put(`/api/v1/subscriptions/resume`);
  },
  verifyEmailSubscriptionToken: (token) => {
    return httpClient.post(`/api/v1/email-subscription/verify-token`, {
      token,
    });
  },
  processEmailSubscription: (token) => {
    return httpClient.post(`/api/v1/email-subscription`, { token });
  },
};

export const emailAccountsAPI = {
  addAccount: (code) => {
    return httpClient.post("/api/v1/email-accounts", { code });
  },
};
